import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core'
import { Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { ActivatedRoute, Params } from '@angular/router'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentField, EnrollmentFieldCodes } from '../../models/enrollment-field'
import { BeneficiaryInfo } from '../../models/enrollments'
import { EappUpdateStatus } from '../../models/eapp-status-model'
import { UserProfileGateway } from '../../../user-management/gateways/user-profile-gateway'
import { UserProfile } from '../../../user-management/models/user-profile'
import * as moment from 'moment'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'VerifyEApp',
    templateUrl: 'verify.component.html'
})
export class VerifyEAppComponent implements OnInit {
    verifyEAP: any = {
        medicareNumber: '',
        firstName: '',
        lastName: '',
        DOB: null
    } as any
    userName: string = ''
    medicareNumber: string = ''
    lastName: string = ''
    DOB: Date | null = null
    counter: number = 0
    disabled: boolean = false
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    private uniqueLink: string
    enrollment: BeneficiaryInfo = {} as BeneficiaryInfo
    isValid: boolean = true
    showPage: boolean = false
    ErrorMessages: any[]
    eappUpdateStatusModel: EappUpdateStatus = {} as EappUpdateStatus
    agentId: number
    userProfileModel: UserProfile
    linkExpired: boolean
    appStatus: string
    showUpdatesSettingsMessage = 'Success'
    LinkExpired: boolean
    ApplicationStatus: string
    FormCompleted: boolean
    public loading: boolean = false
    constructor(
        private _router: Router,
        private route: ActivatedRoute,
        private _enrollmentGateway: EnrollmentGateway,
        private userProfileGateway: UserProfileGateway,
        public _global: PortalGlobals
    ) {
        this.userProfileModel = {} as UserProfile
    }

    ngOnInit() {
        this.getParams()
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this._enrollmentGateway.getEappDetails(this.uniqueLink).subscribe((model: any) => {
            this.LinkExpired = model.LinkExpired
            this.ApplicationStatus = model.ApplicationStatus
            this.FormCompleted = model.FormCompleted
            this._enrollmentGateway.getEnrollmentAppDetails(this.uniqueLink).subscribe((model: EnrollmentField[]) => {
                for (let i = 0; i < model.length; i++) {
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPFN) {
                        this.enrollment.firstName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPLN) {
                        this.enrollment.lastName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.HICN) {
                        this.enrollment.medicareId = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPDOB) {
                        this.enrollment.dateOfBirth = new Date(model[i].FieldValue)
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.AGENTID) {
                        this.agentId = Number(model[i].FieldValue)
                    }
                }
                if (!this.validate()) {
                    this._router.navigate(['/' + insCo + '/enrollment/e-application/messages/' + '3'])
                } else {
                    this.showPage = true
                }
            })
        })
    }

    validate(): boolean {
        this.isValid = true
        if (this.LinkExpired == true) {
            this.isValid = false
        }
        if (this.ApplicationStatus == 'Correction') {
            this.isValid = false
        }
        if (this.FormCompleted == true) {
            this.isValid = false
        }
        return this.isValid
    }

    verify() {
        let dob1 = moment(this.DOB, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        let dob2 = moment(this.enrollment.dateOfBirth, 'MM/DD/YYYY', true).format('MM/DD/YYYY')
        if (this.IsDataVerify(dob1, dob2)) {
            this.eappUpdateStatusModel.ApplicationStatus = 'Viewed'
            this.eappUpdateStatusModel.UniqueLink = this.uniqueLink
            this.eappUpdateStatusModel.LinkExpired = false
            this.eappUpdateStatusModel.LinkViewed = true
            this.eappUpdateStatusModel.Reason = ''
            this.eappUpdateStatusModel.PasswordCount = 0
            this.loading = true
            this._enrollmentGateway.updateEAppStatus(this.eappUpdateStatusModel).subscribe(
                (model: any) => {
                    let response = model
                    if (response !== undefined) {
                        this.loading = false
                        this._router.navigate(['/' + insCo + '/enrollment/e-app/' + this.uniqueLink + '/' + 'verify'])
                    }
                    this.loading = false
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.counter++
            if (this.counter >= 3) {
                console.log('Three tries exceeded.')
                this.eappUpdateStatusModel.ApplicationStatus = 'Failed'
                this.eappUpdateStatusModel.UniqueLink = this.uniqueLink
                this.eappUpdateStatusModel.LinkExpired = false
                this.eappUpdateStatusModel.LinkViewed = true
                this.eappUpdateStatusModel.PasswordCount = 3
                this.eappUpdateStatusModel.Reason = 'Identity could not be confirmed'
                this.loading = true
                this._enrollmentGateway.updateEAppStatus(this.eappUpdateStatusModel).subscribe(
                    (model: any) => {
                        let response = model
                        if (response !== undefined) {
                            this.userProfileGateway.findUserProfileByProfileID(this.agentId).subscribe(
                                (model: UserProfile) => {
                                    this.userProfileModel = model
                                    if (this.userProfileModel.Email !== null && this.userProfileModel.Email !== undefined) {
                                        this._enrollmentGateway
                                            .SendAgentEmail(
                                                this.userProfileModel.Email,
                                                this.userProfileModel.FirstName + '' + this.userProfileModel.LastName,
                                                this.agentId,
                                                this.enrollment.firstName
                                            )
                                            .subscribe(() => (this.showUpdatesSettingsMessage = 'Success'))
                                        this.loading = false
                                        this._router.navigate(['/' + insCo + '/enrollment/e-application/messages/' + '3'])
                                    }
                                    this.loading = false
                                },
                                (err) => {
                                    this.loading = false
                                }
                            )
                        }
                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            }
        }
    }

    getParams() {
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params['guid']
        })
    }

    IsDataVerify(dob1: string, dob2: string): boolean {
        this.ErrorMessages = [] as any[]
        this.isValid = true
        if (this.medicareNumber !== this.enrollment.medicareId) {
            this.ErrorMessages.push('Please enter a valid Medicare Number, using only numbers and letters. Do not include hyphens.')
            this.isValid = false
        }
        if (this.lastName.toUpperCase() !== this.enrollment.lastName.toUpperCase()) {
            this.ErrorMessages.push('Please enter a valid Last Name')
            this.isValid = false
        }
        if (dob1 !== dob2) {
            this.ErrorMessages.push('Please enter a valid Date of Birth')
            this.isValid = false
        }
        return this.isValid
    }
}
